module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-message--file"
  }, [_c('div', {
    staticClass: "sc-message--file-icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.data.file.url || '#',
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/file.svg"),
      "alt": "generic file icon",
      "height": "60"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sc-message--file-name"
  }, [_c('a', {
    attrs: {
      "href": _vm.data.file.url ? _vm.data.file.url : '#',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.data.file.name || ''))])]), _vm._v(" "), _c('div', {
    staticClass: "sc-message--file-text"
  }, [_vm._v(_vm._s(_vm.data.text)), (_vm.data.meta) ? _c('p', {
    staticClass: "sc-message--meta"
  }, [_vm._v(_vm._s(_vm.data.meta))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e033bc0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-beautiful-chat/src/FileMessage.vue
// module id = 1202
// module chunks = 1